// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Resizeable.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, view, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const Resizeable = () => <view.div css={{
  layout: 'column',
  gap: 'medium',
  '& > *': {
    width: css.value('350px')
  }
}}>
    <TextArea label="Resizable bio" defaultValue={EXAMPLE_TEXT} />
    <TextArea label="Unresizable bio" resizeable={false} defaultValue={EXAMPLE_TEXT} />
  </view.div>;